module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27766",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4296",
      "atom": "static-1.4709",
      "conversations-async-data": "static-2.7295",
      "conversations-error-reporting": "static-1.8512",
      "conversations-infrastructure": "static-1.8534",
      "conversations-internal-pub-sub": "static-1.15595",
      "conversations-internal-schema": "static-1.12249",
      "conversations-message-history": "static-1.11499",
      "conversations-test-sdk": "static-1.10091",
      "conversations-visitor-experience-components": "static-1.21129",
      "head-dlb": "static-1.4465",
      "hs-promise-utils": "static-1.5183",
      "hs-test-utils": "static-1.7591",
      "hubspot-dlb": "static-2.1744",
      "HubStyleTokens": "static-2.11051",
      "I18n": "static-7.1517",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2612",
      "jasmine-runner": "static-1.6058",
      "quartz": "static-1.6451",
      "react-dlb": "static-1.67",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4077",
      "StyleGuideUI": "static-3.481",
      "transmute": "static-2.77",
      "urlinator": "static-1.4160",
      "usage-tracker": "static-1.6967",
      "usage-tracker-core": "static-1.6817",
      "usage-tracker-public": "static-1.6778",
      "viral-links-lib": "static-1.6615",
      "visitor-ui-component-library": "static-1.5761",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4375",
      "conversations-prop-types": "static-1.7047",
      "conversations-visibility-tools": "static-1.5347",
      "conversations-visitor-message-history": "static-1.19866",
      "cssUtils": "static-1.670",
      "enviro": "static-4.345",
      "flux-actions": "static-1.293",
      "foundations-components": "static-1-ak-nestedtablestyle.36",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3768",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9233",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "react": "static-7.151",
      "react-aria": "static-1.57",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.16256",
      "react-utils": "static-2.4998",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7748",
      "signup-constants": "static-1.17989",
      "styled-components": "static-2.64",
      "usage-tracker-multi": "static-1.5381",
      "visitor-ui-component-library-icons": "static-1.5572",
      "hs-promise-rejection-tracking": "static-1.4918",
      "raven-hubspot": "static-1.5693",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3072",
      "moment": "static-3.26",
      "quartz-config": "static-1.229",
      "quartz-core": "static-1.5670",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4432",
      "foundations-theming": "static-1.4005",
      "UIComponents": "static-3.7998",
      "cv-backend-services": "static-1.1413",
      "immutable-less": "static-1.4246",
      "conversations-skeleton-state": "static-1.6885",
      "crm-events-viz-core": "static-1.31911",
      "customer-agent-discovery-components-lib": "static-1.1982",
      "customer-data-objects": "static-1.7241",
      "data-fetching-client": "static-1.9277",
      "icons": "static-2.601",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4237",
      "tanstack-virtual": "static-1.23",
      "ui-images": "static-2.1029",
      "HeadJS": "static-2.670",
      "framer-motion": "static-1.61",
      "hs-test-utils-bend-plugin": "static-1.2702",
      "msw": "static-1.39",
      "testing-library": "static-1.144",
      "i18n-data": "static-1.214",
      "moment-timezone": "static-5.76",
      "jasmine": "static-4.3929",
      "history": "static-4.47",
      "signup-ui-url-generator": "static-2.7657",
      "HubStyle": "static-2.11359",
      "quartz-i18n": "static-1.126",
      "sassPrefix": "static-1.148",
      "bend-plugin-foundations-components": "static-1-ak-nestedtablestyle.36",
      "floating-ui": "static-1.49",
      "foundations-theming-specialty": "static-1.1721",
      "hs-story-utils": "static-1.9030",
      "react-virtualized": "static-2.90",
      "tanstack-table": "static-1.23",
      "trellis-assets": "static-1.864",
      "ui-fonts": "static-1.337",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3575",
      "usage-tracker-anonymous": "static-1.5384",
      "bender-build-tools": "static-1.2729",
      "dispatcher": "static-1.128",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.749",
      "hubspotter-http": "static-1.4294",
      "mobile-manifest-mixins": "static-1.443",
      "quartz-auth": "static-1.126",
      "quartz-head": "static-1.116",
      "quartz-test": "static-1.126",
      "bend-plugin-foundations-theming": "static-1.2488",
      "foundations-theming-base": "static-1.2990",
      "stylex": "static-1.25",
      "ts-schema": "static-1.3752",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.2096",
      "content-assistance-lib": "static-1.7209",
      "crm-component-utils": "static-1.38044",
      "crm-display-components": "static-1.23794",
      "crm-fe-perf": "static-1.22512",
      "crm-links": "static-1.5842",
      "crm-message-bus": "static-1.41885",
      "crm-search-service-types": "static-1.815",
      "crm-source-interpretation-lib": "static-1.4936",
      "customer-data-communicator": "static-1.44416",
      "customer-data-email": "static-1.17359",
      "customer-data-filters-ui": "static-1.38263",
      "customer-data-objects-ui-components": "static-1.12593",
      "customer-data-properties": "static-1.50259",
      "customer-data-rte": "static-1.32054",
      "customer-data-ui-utilities": "static-1.9433",
      "draft-plugins": "static-2.20981",
      "file-manager-components": "static-1.22386",
      "FileManagerCore": "static-1.37885",
      "framework-data-schema-resolvers": "static-1.6499",
      "frontend-preferences-client": "static-1.7548",
      "hubspot-apollo-client": "static-1.4476",
      "hubspot-prosemirror": "static-1.17139",
      "object-comments-thread-lib": "static-1.9657",
      "reference-resolvers-lite": "static-1.7693",
      "ui-addon-upgrades": "static-9.17303",
      "universal-associations-select": "static-1.10571",
      "ai-components-ui-library": "static-1.7890",
      "final-form": "static-1.63",
      "inbound-db-properties-service-client": "static-1.3527",
      "property-translator": "static-1.5015",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.75",
      "hub-http-shared-msw-handlers": "static-1.9033",
      "hubspotter-http-shared-msw-handlers": "static-1.9031",
      "superstore": "static-1.4374",
      "ui-addon-video-player": "static-1.8356",
      "ui-coaching-tips": "static-1.27448",
      "card-properties-lib": "static-1.43038",
      "crm-actions": "static-1.5870",
      "crm-cards-data": "static-1.906",
      "crm-cards-sdk": "static-1.42409",
      "customer-data-properties-shared-msw-handlers": "static-1.8360",
      "customer-data-property-utils": "static-1.7662",
      "customer-data-tracking": "static-1.6491",
      "usage-tracker-container": "static-1.6957",
      "framework-data-table": "static-2.11016",
      "location-customization-utils-lib": "static-1.8043",
      "calling-error-reporting": "static-1.30911",
      "calling-internal-common": "static-1.30905",
      "calling-usage-tracker": "static-1.6170",
      "crm_data": "static-4.90663",
      "crm_schema": "static-3.90702",
      "crm-legacy-global-containers": "static-1.23493",
      "customer-data-content": "static-1.26512",
      "draft-content-plugins": "static-1.27355",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23353",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.23126",
      "EmailSignatureEditor": "static-1.23613",
      "FileManagerLib": "static-1.38026",
      "hubspot-prosemirror-plugins": "static-1.17131",
      "integration-settings-components": "static-1.14246",
      "integrations-lib": "static-1.14860",
      "integrations-tracking-lib": "static-1.5212",
      "native-integrations-shared-strings": "static-1.7417",
      "nav-meta": "static-1.28433",
      "onboarding-scopes": "static-1.6076",
      "outreach-assistant-email-generation": "static-1.5443",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36661",
      "react-colorpicker": "static-2.9821",
      "react-dnd-compat": "static-1.4257",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7788",
      "rich-text-lib": "static-1.19148",
      "sales-email-signature-service-client": "static-1.3469",
      "sequences-lib": "static-1.7417",
      "timezone-utils": "static-2.4843",
      "ui-addon-i18n": "static-1.10721",
      "ui-addon-iframeable": "static-1.8604",
      "ui-business-units-lib": "static-1.8608",
      "ui-gdpr-components": "static-1.9951",
      "ui-shepherd-react": "static-3.9742",
      "user-context": "static-1.4713",
      "whatsapp-sending-lib": "static-1.4432",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4285",
      "salesImages": "static-1.517",
      "customer-data-filters-ui-msw-helpers": "static-1.20697",
      "customer-data-reference-ui-components": "static-1.12726",
      "FormUrlGenerator": "static-2.4328",
      "framework-builder-read-service-client": "static-1.3664",
      "framework-data-schema-quick-fetch": "static-1.6404",
      "inbound-db-meta-service-client": "static-1.3306",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.590",
      "onboarding-tours": "static-1.16019",
      "reporting-datasets-permissions-lib": "static-1.12486",
      "SharedI18nStrings": "static-1.179",
      "ui-addon-teams": "static-1.20984",
      "calling-global-api": "static-1.63098",
      "calling-lifecycle-internal": "static-1.64480",
      "calling-lifecycle-messages": "static-1.56774",
      "commerce-products-lib": "static-1.8303",
      "conditional-properties-service-client": "static-1.3468",
      "external-options-client-types": "static-1.3792",
      "google-libphonenumber": "static-1.31",
      "inbound-db-associations-writes-service-client": "static-1.2799",
      "inbounddb-objects-service-types": "static-1.3864",
      "meetings-icalendar-utils-lib": "static-1.233",
      "multi-currency-client-types": "static-1.3335",
      "object-builder-ui-client": "static-1.47422",
      "pipeline-validation-client-types": "static-1.3598",
      "property-value-citations": "static-1.873",
      "smart-property-lib": "static-1.5236",
      "tiered-pricing": "static-1.558",
      "ui-addon-form-validation": "static-1.10605",
      "immerable": "static-1.3751",
      "video-components-external": "static-1.10053",
      "video-data-lib": "static-1.33711",
      "audio-components": "static-1.5376",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35537",
      "ui-universal-auth": "static-1.8435",
      "video-components": "static-1.12056",
      "video-embed": "static-1.34545",
      "batch-promise": "static-1.1163",
      "crm-pipelines-api-client-types": "static-1.3779",
      "persist-promise": "static-1.3320",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24220",
      "knowledge-content-types": "static-1.8232",
      "payment-link-components": "static-1.22449",
      "ui-addon-emoji-picker": "static-1.9489",
      "call-summary": "static-1.37789",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9179",
      "feature-store-service-types": "static-1.4161",
      "growth-monetization-service-types": "static-1.4168",
      "merchandise-lib": "static-1.251",
      "purchase-motions-components": "static-1.5172",
      "self-service-api": "static-1.9827",
      "upgrade-management-service-types": "static-1.4152",
      "chatspot-client-types": "static-1.10271",
      "chatspot-core": "static-1.19675",
      "ContentUtils": "static-1.67101",
      "copilot-toolkit": "static-1.10093",
      "growth-onboarding-feedback-components": "static-1.6192",
      "customer-data-sidebar": "static-2.44948",
      "enrichment-properties-lib": "static-1.14354",
      "customer-data-associations": "static-1.6936",
      "deal-intel-decorators": "static-1.717",
      "reporting-data": "static-1.65788",
      "ui-addon-draggable": "static-3.4381",
      "crm-record-cards-service-types": "static-1.3310",
      "crm_universal": "static-1.21415",
      "SalesContentIndexUI": "static-3.8607",
      "signup-ui-lego-core": "static-1.19999",
      "content-embed-lib": "static-1.6974",
      "data-model-builder-lib": "static-1.11065",
      "remote-ui": "static-1.58",
      "ui-components-test-utils": "static-1.5189",
      "ui-extensions-remote-renderer": "static-1.15985",
      "universal-page-editor-lib": "static-1.2624",
      "integrations-error-boundary-lib": "static-1.12275",
      "laboratory-lib": "static-3.6742",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10005",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.44833",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15757",
      "sequences-client-types-lib": "static-1.7274",
      "foundations-components-test-utils": "static-1-ak-nestedtablestyle.36",
      "magpie-lib": "static-1.5198",
      "navigation-messaging": "static-1.6123",
      "getting-started-shared-tasks": "static-1.17379",
      "getting-started-shared-tasks-store": "static-1.16497",
      "onboarding-tours-utils": "static-1.85",
      "whatsapp-management-lib": "static-1.7591",
      "growth-data-modal": "static-1.4950",
      "growth-onboarding-confetti": "static-1.2656",
      "growth-onboarding-next-action-utils": "static-1.1080",
      "navigation-components": "static-1.16796",
      "onboarding-tours-client": "static-1.4233",
      "ui-shepherd-tracker": "static-1.7123",
      "shared-worker-versioning": "static-1.10650",
      "calling-orchestration-shared-library": "static-1.34281",
      "products-iframe-lib": "static-1.6878",
      "products-ui-components-shared-msw-handlers": "static-1.9415",
      "breeze-intelligence-kit": "static-1.5051",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9116",
      "fsm": "static-1.3336",
      "policy-lib": "static-1.6410",
      "react-tinymce": "static-1.54144",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53270",
      "tinymce-plugins": "static-1.56384",
      "tinymce-themes": "static-1.55240",
      "content-media-composition-data-lib": "static-1.10682",
      "content-media-compositions": "static-2.14689",
      "idb-keyval": "static-1.37",
      "magpie-types": "static-1.4658",
      "media-bridge-lib": "static-1.18289",
      "content-icons-ui": "static-1.2085",
      "social-insights-client-types": "static-1.20933",
      "outpost": "static-1.3855",
      "commerce-analytics-service-client": "static-1.3284",
      "ui-addon-opt": "static-4.8027",
      "commerce-tours-lib": "static-1.5427",
      "growth-onboarding-reliability": "static-1.4723",
      "sales-checkout-service-client": "static-1.3296",
      "ai-addon-copilot-preview": "static-1.7102",
      "calling-cross-tab-library": "static-1.18875",
      "calling-lifecycle-usage-tracker": "static-1.7697",
      "wootric-nps": "static-1.6527",
      "nav-client-types": "static-1.1930",
      "purchase-motions-api": "static-1.5175",
      "trials-service-types": "static-1.3569",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4397",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2651",
      "card-payment-highlight-lib": "static-1.36050",
      "card-subscription-highlight-lib": "static-1.38451",
      "commerce-billing-lib": "static-1.18005",
      "commerce-contract-lib": "static-1.10567",
      "crm_components": "static-3.90663",
      "invoices-highlight-card-lib": "static-1.53474",
      "orders-highlight-card-lib": "static-1.20484",
      "products-highlight-card-lib": "static-1.16587",
      "project-storage": "static-1.4333",
      "quotes-highlight-card-lib": "static-1.70574",
      "usage-based-billing-components-lib": "static-1.7574",
      "deal-intel-utils": "static-1.721",
      "reporting-client-types": "static-1.2333",
      "react-flip-move": "static-1.63",
      "FireAlarmUi": "static-1.4172",
      "sales-templates-service-types-lib": "static-1.3841",
      "ui-asset-management-lib": "static-1.10454",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9147",
      "collaboration-sidebar": "static-1.56697",
      "conditional-property-settings-modal": "static-1.11559",
      "data-model-commons-lib": "static-1.11501",
      "feedback-loader": "static-1.28526",
      "html-to-image": "static-1.47",
      "object-definition-builder-lib": "static-1.6643",
      "property-management-iframe": "static-1.11667",
      "reactflow": "static-1.54",
      "simple-data-table": "static-1.1704",
      "used-in-list-lib": "static-1.6498",
      "visual-association": "static-1.5426",
      "highcharts": "static-8.97",
      "reporting-visualizations": "static-1.57865",
      "ui-extensibility-client-types": "static-1.3596",
      "automation-platform-service-types": "static-1.2406",
      "ContentData": "static-1.67176",
      "email-portal-health-service-types": "static-1.606",
      "marketing-email-service-types": "static-1.1710",
      "reactive-lib": "static-1.329",
      "content-whatsapp-service-types": "static-1.134",
      "marketing-platform-lib": "static-1.6429",
      "short-messages-app-service-client": "static-1.3645",
      "ui-tool-access": "static-1.9733",
      "calling-orchestration-schema": "static-1.34506",
      "sales-views-client-types": "static-1.3892",
      "trellis-story-utils": "static-1.4128",
      "storybook-react": "static-1.25",
      "hub-http-contrib": "static-1.2683",
      "interframe": "static-3.4398",
      "tinymce-data": "static-1.39355",
      "ui-addon-sales-email": "static-1.4816",
      "codemirror": "static-5.88",
      "layout-dnd-components": "static-1.11715",
      "layout-dnd-utils": "static-1.10690",
      "react-codemirror": "static-1.10238",
      "ui-brand-identity-lib": "static-1.13181",
      "NamespacedHubStyle": "static-2.8749",
      "hls.js": "static-1.32",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.8763",
      "ai-settings-ui-library": "static-1.7056",
      "chirp-fetch": "static-1.1518",
      "copilot-plugins": "static-1.10066",
      "eligibility-engine-service-types": "static-1.2850",
      "commerce-shared-components-lib": "static-1.17444",
      "commerce-subscription-lib": "static-1.36028",
      "commerce-tools-ui-lib": "static-1.9386",
      "usage-tracker-session-replay": "static-1.4653",
      "utility-belt": "static-1.2149",
      "payments-enrollment-embed-lib": "static-1.21385",
      "quotes-ui-lib": "static-1.79292",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6407",
      "invoices-ui-lib": "static-1.53490",
      "commerce-products-api": "static-1.1666",
      "SafeStorage": "static-1.3994",
      "invoices-iframe-lib": "static-1.55548",
      "quotes-modal-lib": "static-1.101249",
      "reporting-ui-components": "static-2.63061",
      "subscription-experience-data-types": "static-1.14324",
      "association-translator": "static-1.2795",
      "crm-settings-header-lib": "static-1.7891",
      "settings-ui-nav": "static-2.9773",
      "chatspot-widget-iframe": "static-1.19667",
      "collaboration-sidebar-common": "static-1.1493",
      "crm-properties-common-lib": "static-1.5470",
      "ui-addon-draggable-compat": "static-2.3887",
      "property-management-common": "static-1.3954",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14535",
      "advanced-menus-lib": "static-1.11542",
      "ExportDialog": "static-6.10011",
      "ui-memberships-settings-lib": "static-1.32935",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9015",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13022",
      "highlight.js": "static-1.72",
      "reporting-action-components": "static-1.40233",
      "ui-addon-react-router-dom": "static-1.9173",
      "growth-onboarding-empty-states": "static-1.5120",
      "InboxConnectUtils": "static-4.13789",
      "payments-post-enroll-local-storage-lib": "static-1.4687",
      "qrcode-generator": "static-1.62",
      "amplitude-session-replay-browser": "static-1.53",
      "marketplace-ui-apps-core": "static-1.17005",
      "stripe-embedded-components": "static-1.6850",
      "products-ui-components": "static-1.38822",
      "totals-ui-components": "static-1.22528",
      "reporting-plugins": "static-1.9714",
      "reporting-reports": "static-1.65467",
      "reporting-snowflake": "static-1.54407",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14534",
      "simple-menus-lib": "static-1.16051",
      "academy-common-lib": "static-1.12482",
      "dashboard-lib": "static-1.79956",
      "share-with-third-party-component-lib": "static-1.8286",
      "developer-experience-shared-components": "static-1.10006",
      "marketplace-ui-client-types": "static-1.15878",
      "marketplace-ui-common": "static-1.18471",
      "ui-addon-integrations-directory-panel": "static-2.7611",
      "stripe-connect-js": "static-1.43",
      "commerce-permissions": "static-1.346",
      "property-description-translator": "static-1.3462",
      "commerce-totals-service-types": "static-1.3450",
      "campaign-roi-lib": "static-1.7762",
      "academy-service-client": "static-1.3282",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3506",
      "oauth-service-types": "static-1.3836",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27766",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4296",
      "atom": "/atom/static-1.4709",
      "conversations-async-data": "/conversations-async-data/static-2.7295",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8512",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8534",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15595",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12249",
      "conversations-message-history": "/conversations-message-history/static-1.11499",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10091",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21129",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-promise-utils": "/hs-promise-utils/static-1.5183",
      "hs-test-utils": "/hs-test-utils/static-1.7591",
      "hubspot-dlb": "/hubspot-dlb/static-2.1744",
      "HubStyleTokens": "/HubStyleTokens/static-2.11051",
      "I18n": "/I18n/static-7.1517",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2612",
      "jasmine-runner": "/jasmine-runner/static-1.6058",
      "quartz": "/quartz/static-1.6451",
      "react-dlb": "/react-dlb/static-1.67",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4077",
      "StyleGuideUI": "/StyleGuideUI/static-3.481",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4160",
      "usage-tracker": "/usage-tracker/static-1.6967",
      "usage-tracker-core": "/usage-tracker-core/static-1.6817",
      "usage-tracker-public": "/usage-tracker-public/static-1.6778",
      "viral-links-lib": "/viral-links-lib/static-1.6615",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5761",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4375",
      "conversations-prop-types": "/conversations-prop-types/static-1.7047",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5347",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19866",
      "cssUtils": "/cssUtils/static-1.670",
      "enviro": "/enviro/static-4.345",
      "flux-actions": "/flux-actions/static-1.293",
      "foundations-components": "/foundations-components/static-1-ak-nestedtablestyle.36",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3768",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9233",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.57",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.16256",
      "react-utils": "/react-utils/static-2.4998",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7748",
      "signup-constants": "/signup-constants/static-1.17989",
      "styled-components": "/styled-components/static-2.64",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5381",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5572",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3072",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.229",
      "quartz-core": "/quartz-core/static-1.5670",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4432",
      "foundations-theming": "/foundations-theming/static-1.4005",
      "UIComponents": "/UIComponents/static-3.7998",
      "cv-backend-services": "/cv-backend-services/static-1.1413",
      "immutable-less": "/immutable-less/static-1.4246",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6885",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31911",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.1982",
      "customer-data-objects": "/customer-data-objects/static-1.7241",
      "data-fetching-client": "/data-fetching-client/static-1.9277",
      "icons": "/icons/static-2.601",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4237",
      "tanstack-virtual": "/tanstack-virtual/static-1.23",
      "ui-images": "/ui-images/static-2.1029",
      "HeadJS": "/HeadJS/static-2.670",
      "framer-motion": "/framer-motion/static-1.61",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2702",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.144",
      "i18n-data": "/i18n-data/static-1.214",
      "moment-timezone": "/moment-timezone/static-5.76",
      "jasmine": "/jasmine/static-4.3929",
      "history": "/history/static-4.47",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7657",
      "HubStyle": "/HubStyle/static-2.11359",
      "quartz-i18n": "/quartz-i18n/static-1.126",
      "sassPrefix": "/sassPrefix/static-1.148",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ak-nestedtablestyle.36",
      "floating-ui": "/floating-ui/static-1.49",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1721",
      "hs-story-utils": "/hs-story-utils/static-1.9030",
      "react-virtualized": "/react-virtualized/static-2.90",
      "tanstack-table": "/tanstack-table/static-1.23",
      "trellis-assets": "/trellis-assets/static-1.864",
      "ui-fonts": "/ui-fonts/static-1.337",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3575",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5384",
      "bender-build-tools": "/bender-build-tools/static-1.2729",
      "dispatcher": "/dispatcher/static-1.128",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.749",
      "hubspotter-http": "/hubspotter-http/static-1.4294",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.443",
      "quartz-auth": "/quartz-auth/static-1.126",
      "quartz-head": "/quartz-head/static-1.116",
      "quartz-test": "/quartz-test/static-1.126",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2488",
      "foundations-theming-base": "/foundations-theming-base/static-1.2990",
      "stylex": "/stylex/static-1.25",
      "ts-schema": "/ts-schema/static-1.3752",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.2096",
      "content-assistance-lib": "/content-assistance-lib/static-1.7209",
      "crm-component-utils": "/crm-component-utils/static-1.38044",
      "crm-display-components": "/crm-display-components/static-1.23794",
      "crm-fe-perf": "/crm-fe-perf/static-1.22512",
      "crm-links": "/crm-links/static-1.5842",
      "crm-message-bus": "/crm-message-bus/static-1.41885",
      "crm-search-service-types": "/crm-search-service-types/static-1.815",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4936",
      "customer-data-communicator": "/customer-data-communicator/static-1.44416",
      "customer-data-email": "/customer-data-email/static-1.17359",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38263",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12593",
      "customer-data-properties": "/customer-data-properties/static-1.50259",
      "customer-data-rte": "/customer-data-rte/static-1.32054",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9433",
      "draft-plugins": "/draft-plugins/static-2.20981",
      "file-manager-components": "/file-manager-components/static-1.22386",
      "FileManagerCore": "/FileManagerCore/static-1.37885",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6499",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7548",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4476",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17139",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9657",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7693",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17303",
      "universal-associations-select": "/universal-associations-select/static-1.10571",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7890",
      "final-form": "/final-form/static-1.63",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3527",
      "property-translator": "/property-translator/static-1.5015",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.75",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9033",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9031",
      "superstore": "/superstore/static-1.4374",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8356",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27448",
      "card-properties-lib": "/card-properties-lib/static-1.43038",
      "crm-actions": "/crm-actions/static-1.5870",
      "crm-cards-data": "/crm-cards-data/static-1.906",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42409",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8360",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7662",
      "customer-data-tracking": "/customer-data-tracking/static-1.6491",
      "usage-tracker-container": "/usage-tracker-container/static-1.6957",
      "framework-data-table": "/framework-data-table/static-2.11016",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8043",
      "calling-error-reporting": "/calling-error-reporting/static-1.30911",
      "calling-internal-common": "/calling-internal-common/static-1.30905",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6170",
      "crm_data": "/crm_data/static-4.90663",
      "crm_schema": "/crm_schema/static-3.90702",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23493",
      "customer-data-content": "/customer-data-content/static-1.26512",
      "draft-content-plugins": "/draft-content-plugins/static-1.27355",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23353",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23126",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23613",
      "FileManagerLib": "/FileManagerLib/static-1.38026",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17131",
      "integration-settings-components": "/integration-settings-components/static-1.14246",
      "integrations-lib": "/integrations-lib/static-1.14860",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5212",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7417",
      "nav-meta": "/nav-meta/static-1.28433",
      "onboarding-scopes": "/onboarding-scopes/static-1.6076",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5443",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36661",
      "react-colorpicker": "/react-colorpicker/static-2.9821",
      "react-dnd-compat": "/react-dnd-compat/static-1.4257",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7788",
      "rich-text-lib": "/rich-text-lib/static-1.19148",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3469",
      "sequences-lib": "/sequences-lib/static-1.7417",
      "timezone-utils": "/timezone-utils/static-2.4843",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10721",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8604",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8608",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9951",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9742",
      "user-context": "/user-context/static-1.4713",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4432",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4285",
      "salesImages": "/salesImages/static-1.517",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20697",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12726",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4328",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3664",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6404",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3306",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.590",
      "onboarding-tours": "/onboarding-tours/static-1.16019",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12486",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
      "ui-addon-teams": "/ui-addon-teams/static-1.20984",
      "calling-global-api": "/calling-global-api/static-1.63098",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64480",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56774",
      "commerce-products-lib": "/commerce-products-lib/static-1.8303",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3468",
      "external-options-client-types": "/external-options-client-types/static-1.3792",
      "google-libphonenumber": "/google-libphonenumber/static-1.31",
      "inbound-db-associations-writes-service-client": "/inbound-db-associations-writes-service-client/static-1.2799",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3864",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.233",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3335",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47422",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3598",
      "property-value-citations": "/property-value-citations/static-1.873",
      "smart-property-lib": "/smart-property-lib/static-1.5236",
      "tiered-pricing": "/tiered-pricing/static-1.558",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10605",
      "immerable": "/immerable/static-1.3751",
      "video-components-external": "/video-components-external/static-1.10053",
      "video-data-lib": "/video-data-lib/static-1.33711",
      "audio-components": "/audio-components/static-1.5376",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35537",
      "ui-universal-auth": "/ui-universal-auth/static-1.8435",
      "video-components": "/video-components/static-1.12056",
      "video-embed": "/video-embed/static-1.34545",
      "batch-promise": "/batch-promise/static-1.1163",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3779",
      "persist-promise": "/persist-promise/static-1.3320",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24220",
      "knowledge-content-types": "/knowledge-content-types/static-1.8232",
      "payment-link-components": "/payment-link-components/static-1.22449",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9489",
      "call-summary": "/call-summary/static-1.37789",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9179",
      "feature-store-service-types": "/feature-store-service-types/static-1.4161",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4168",
      "merchandise-lib": "/merchandise-lib/static-1.251",
      "purchase-motions-components": "/purchase-motions-components/static-1.5172",
      "self-service-api": "/self-service-api/static-1.9827",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4152",
      "chatspot-client-types": "/chatspot-client-types/static-1.10271",
      "chatspot-core": "/chatspot-core/static-1.19675",
      "ContentUtils": "/ContentUtils/static-1.67101",
      "copilot-toolkit": "/copilot-toolkit/static-1.10093",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6192",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44948",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14354",
      "customer-data-associations": "/customer-data-associations/static-1.6936",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.717",
      "reporting-data": "/reporting-data/static-1.65788",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4381",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3310",
      "crm_universal": "/crm_universal/static-1.21415",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8607",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19999",
      "content-embed-lib": "/content-embed-lib/static-1.6974",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11065",
      "remote-ui": "/remote-ui/static-1.58",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5189",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15985",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2624",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12275",
      "laboratory-lib": "/laboratory-lib/static-3.6742",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10005",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.44833",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15757",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7274",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ak-nestedtablestyle.36",
      "magpie-lib": "/magpie-lib/static-1.5198",
      "navigation-messaging": "/navigation-messaging/static-1.6123",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17379",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16497",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.85",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7591",
      "growth-data-modal": "/growth-data-modal/static-1.4950",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2656",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1080",
      "navigation-components": "/navigation-components/static-1.16796",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4233",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7123",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10650",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34281",
      "products-iframe-lib": "/products-iframe-lib/static-1.6878",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9415",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5051",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9116",
      "fsm": "/fsm/static-1.3336",
      "policy-lib": "/policy-lib/static-1.6410",
      "react-tinymce": "/react-tinymce/static-1.54144",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53270",
      "tinymce-plugins": "/tinymce-plugins/static-1.56384",
      "tinymce-themes": "/tinymce-themes/static-1.55240",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10682",
      "content-media-compositions": "/content-media-compositions/static-2.14689",
      "idb-keyval": "/idb-keyval/static-1.37",
      "magpie-types": "/magpie-types/static-1.4658",
      "media-bridge-lib": "/media-bridge-lib/static-1.18289",
      "content-icons-ui": "/content-icons-ui/static-1.2085",
      "social-insights-client-types": "/social-insights-client-types/static-1.20933",
      "outpost": "/outpost/static-1.3855",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3284",
      "ui-addon-opt": "/ui-addon-opt/static-4.8027",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5427",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4723",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3296",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7102",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18875",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.7697",
      "wootric-nps": "/wootric-nps/static-1.6527",
      "nav-client-types": "/nav-client-types/static-1.1930",
      "purchase-motions-api": "/purchase-motions-api/static-1.5175",
      "trials-service-types": "/trials-service-types/static-1.3569",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4397",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2651",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36050",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38451",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18005",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10567",
      "crm_components": "/crm_components/static-3.90663",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53474",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20484",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16587",
      "project-storage": "/project-storage/static-1.4333",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70574",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7574",
      "deal-intel-utils": "/deal-intel-utils/static-1.721",
      "reporting-client-types": "/reporting-client-types/static-1.2333",
      "react-flip-move": "/react-flip-move/static-1.63",
      "FireAlarmUi": "/FireAlarmUi/static-1.4172",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3841",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10454",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9147",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56697",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11559",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11501",
      "feedback-loader": "/feedback-loader/static-1.28526",
      "html-to-image": "/html-to-image/static-1.47",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6643",
      "property-management-iframe": "/property-management-iframe/static-1.11667",
      "reactflow": "/reactflow/static-1.54",
      "simple-data-table": "/simple-data-table/static-1.1704",
      "used-in-list-lib": "/used-in-list-lib/static-1.6498",
      "visual-association": "/visual-association/static-1.5426",
      "highcharts": "/highcharts/static-8.97",
      "reporting-visualizations": "/reporting-visualizations/static-1.57865",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3596",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2406",
      "ContentData": "/ContentData/static-1.67176",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.606",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1710",
      "reactive-lib": "/reactive-lib/static-1.329",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.134",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6429",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3645",
      "ui-tool-access": "/ui-tool-access/static-1.9733",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34506",
      "sales-views-client-types": "/sales-views-client-types/static-1.3892",
      "trellis-story-utils": "/trellis-story-utils/static-1.4128",
      "storybook-react": "/storybook-react/static-1.25",
      "hub-http-contrib": "/hub-http-contrib/static-1.2683",
      "interframe": "/interframe/static-3.4398",
      "tinymce-data": "/tinymce-data/static-1.39355",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4816",
      "codemirror": "/codemirror/static-5.88",
      "layout-dnd-components": "/layout-dnd-components/static-1.11715",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10690",
      "react-codemirror": "/react-codemirror/static-1.10238",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13181",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8749",
      "hls.js": "/hls.js/static-1.32",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.8763",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7056",
      "chirp-fetch": "/chirp-fetch/static-1.1518",
      "copilot-plugins": "/copilot-plugins/static-1.10066",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2850",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17444",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36028",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9386",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4653",
      "utility-belt": "/utility-belt/static-1.2149",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21385",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79292",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6407",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53490",
      "commerce-products-api": "/commerce-products-api/static-1.1666",
      "SafeStorage": "/SafeStorage/static-1.3994",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55548",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101249",
      "reporting-ui-components": "/reporting-ui-components/static-2.63061",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14324",
      "association-translator": "/association-translator/static-1.2795",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7891",
      "settings-ui-nav": "/settings-ui-nav/static-2.9773",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19667",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1493",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5470",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3887",
      "property-management-common": "/property-management-common/static-1.3954",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14535",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11542",
      "ExportDialog": "/ExportDialog/static-6.10011",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32935",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9015",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13022",
      "highlight.js": "/highlight.js/static-1.72",
      "reporting-action-components": "/reporting-action-components/static-1.40233",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9173",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5120",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13789",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4687",
      "qrcode-generator": "/qrcode-generator/static-1.62",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17005",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6850",
      "products-ui-components": "/products-ui-components/static-1.38822",
      "totals-ui-components": "/totals-ui-components/static-1.22528",
      "reporting-plugins": "/reporting-plugins/static-1.9714",
      "reporting-reports": "/reporting-reports/static-1.65467",
      "reporting-snowflake": "/reporting-snowflake/static-1.54407",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14534",
      "simple-menus-lib": "/simple-menus-lib/static-1.16051",
      "academy-common-lib": "/academy-common-lib/static-1.12482",
      "dashboard-lib": "/dashboard-lib/static-1.79956",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8286",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10006",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15878",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18471",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7611",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "commerce-permissions": "/commerce-permissions/static-1.346",
      "property-description-translator": "/property-description-translator/static-1.3462",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3450",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7762",
      "academy-service-client": "/academy-service-client/static-1.3282",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3506",
      "oauth-service-types": "/oauth-service-types/static-1.3836",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};